registerComponent("templates/footer", function (component) {
/**
 * O corpo recebe o elemento raiz do componente em `component`; o build o
 * envolve em registerComponent(). Os antigos `params` viraram @props no Blade.
 *
 * Três comportamentos, todos transpostos no mesmo sub-lote que os ouvintes:
 * o "voltar ao topo" (era `Navigation.helpers.scrollTo(0)`, agora
 * `Asa.legado.rolarPara(0)`) e os dois pares de modal, que deixaram de
 * conversar por `$.trigger('open')` e passaram a conversar por `CustomEvent`.
 */

const goToTop = component.querySelector('.go-to-top');
const btnsModalDocs = component.querySelectorAll('[data-open-modal-docs]');
const btnsModalFaq = component.querySelectorAll('[data-open-modal-faq]');

const modalDocs = document.querySelector('[data-component-name="modals/modal-docs"]');
const modalFaq = document.querySelector('[data-component-name="modals/modal-faq"]');

if (goToTop) {
    goToTop.addEventListener('click', function () {
        Asa.legado.rolarPara(0);
    });
}

btnsModalDocs.forEach(function (botao) {
    botao.addEventListener('click', function () {
        if (modalDocs) {
            // O nome da aba ia no segundo argumento do trigger; agora vai no
            // `detail`, que é onde o `_modal-docs.js` o lê.
            modalDocs.dispatchEvent(new CustomEvent('open', { detail: botao.dataset.openModalDocs }));
        }
    });
});

btnsModalFaq.forEach(function (botao) {
    botao.addEventListener('click', function () {
        if (modalFaq) {
            modalFaq.dispatchEvent(new CustomEvent('open'));
        }
    });
});

});
